import { OrderByInput } from '../../generated/graphql';
import { SortResults } from './SortResults';
import { useIntl } from 'react-intl';
import * as S from './ListingCounter.style';
import { EuiLoadingSpinner } from '@elastic/eui';

export interface ListingCounterProps {
  isLoading: boolean;
  count: number;
  uniqueCount: number;
  sorting: OrderByInput;
  onChange: (order: OrderByInput) => void;
  disabled?: boolean;
}

export const ListingCounter = ({
  disabled = false,
  isLoading,
  count,
  uniqueCount,
  sorting,
  onChange,
}: ListingCounterProps): JSX.Element => {
  const { formatMessage, formatNumber } = useIntl();
  return (
    <S.ListingCounter>
      <p>{formatMessage({ id: 'listing.count' })}</p>
      <S.ListingCounterCount>
        {isLoading ? <EuiLoadingSpinner /> : isNaN(count) ? 0 : formatNumber(count, { notation: 'compact' })}
      </S.ListingCounterCount>
      <p>{formatMessage({ id: 'unique-vehicles' })}</p>
      <S.ListingCounterCount>
        {isLoading ? (
          <EuiLoadingSpinner />
        ) : isNaN(uniqueCount) ? (
          0
        ) : (
          formatNumber(uniqueCount, { notation: 'compact' })
        )}
      </S.ListingCounterCount>
      <SortResults sorting={sorting} onChange={disabled ? (): void => {} : onChange} />
    </S.ListingCounter>
  );
};
